// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function customFilter() {

    var self = this,
        $cache = {};

    function openFilter() {
        var tl = new TimelineMax({paused: true, onStart: function() {
            $cache.listHide.addClass('is-active');
          }});

        var h = $cache.listHide.outerHeight();

        tl.to($cache.listWrapper, 0.5, {height: h, force3D: true, ease: Expo.easeOut}, 0);
        //tl.fromTo($cache.listWrapper, 0.5, {height: "0"}, {height: "100%", force3D: true, ease: Power3.easeOut}, 0);
        tl.fromTo($cache.listHide, 0.4, {opacity: 0}, {opacity: 1, ease: Quad.easeInOut}, 0.5);
        //tl.fromTo($cache.fixedNavMbContent, 0.6, {x: 200}, {x: 0, force3D: true, ease: Power2.easeOut}, 0.2);

        tl.play();
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
        $cache.html = $('html');
        $cache.body = $cache.html.find('body');
        $cache.main = $cache.body.find('.main');

        $cache.listCategories   = $cache.customFilter.find('#list-categories');
        $cache.itemDefault      = $cache.listCategories.find('.default');
        $cache.listWrapper      = $cache.listCategories.find('.list-wrapper');
        $cache.listHide         = $cache.listCategories.find('.list-hide');
        $cache.listItem         = $cache.listHide.find('.list-item');
    }

    /**
     * Register Events
     */
    function registerEvents() {

        $cache.itemDefault.on('click', function() {
            openFilter();
        })
      /* $cache.slider.on('init', function(slick){
        window.cache.$window.trigger('resize');
      }).on('reInit', function(slick){
        window.cache.$window.trigger('resize');
      }).on('afterChange', function(slick){
        window.cache.$window.trigger('resize');
      });

      window.cache.$window.on('resize', function() {
        $cache.slickList = $cache.slider.find('.slick-list');
        $cache.slides = $cache.slider.find('.slide');

        setTimeout(function(){ 
          if(typeof $cache.slider.slick === 'function' && $cache.slickList !== undefined) {
            $cache.slickList.css('height', 'auto');
            $cache.slides.css('height', 'auto');

            var height = 0;
            $cache.slides.each(function(){
              var h = $(this).height();
              if(h > height) height = h;
            });

            $cache.slickList.height(height);
            $cache.slides.height(height);
          }
        }, 150);
      });

      $cache.prev.on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('is-disabled')) return;
        if(typeof $cache.slider.slick === 'function') $cache.slider.slick('slickPrev');
      });

      $cache.prev.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.prev.trigger('click');
        }
      });

      $cache.next.on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('is-disabled')) return;
        if(typeof $cache.slider.slick === 'function') $cache.slider.slick('slickNext');
      });

      $cache.next.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.next.trigger('click');
        }
      }); */
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {    
        $cache.customFilter = target;  
        initCache(target);
        registerEvents();

      //initSliders();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.customFilter = customFilter;
  
}(jQuery));
